/**
 * Produtos relacionados: busca as recomendações na API da Shopify e troca o conteúdo do elemento.
 * A URL vem do atributo data-url (já inclui section_id, product_id, limit e intent).
 */
if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url || this.dataset.loaded) return;
        this.dataset.loaded = 'true';

        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'text/html');
            const incoming = parsed.querySelector('product-recommendations');
            if (incoming && incoming.innerHTML.trim().length > 0) {
              this.innerHTML = incoming.innerHTML;
              // O conteúdo chegou depois da primeira varredura do scroll-reveal.js: sem isto,
              // os elementos com [data-animate] injetados agora nunca seriam observados.
              window.themeReveal?.observe(this.querySelectorAll('[data-animate]'));
              // O <script src="carousel.js"> que vem dentro do HTML buscado não executa (script
              // inserido via innerHTML fica inerte) — inicializa o carrossel manualmente aqui.
              window.themeCarousel?.init(this.querySelectorAll('[data-carousel]'));
            }
          })
          .catch(() => {
            // Sem recomendações: a seção permanece vazia, sem quebrar a página.
          });
      }
    },
  );
}
